import PropTypes from "prop-types";
import React, { useState } from "react";
import CheckIcon from '@mui/icons-material/Check';
import ToggleButton from '@mui/material/ToggleButton';
import toast from "react-hot-toast";
import useApi from "../Utils/api";

function MerchantSettlementStatusChangeSelectField(props) {
    const { value, index, ...other } = props;
    const [status, setStatus] = useState(parseInt(value, 10) ?? 0);

    const api = useApi();

    const changeMerchantStatus = (statusValue) => {
        console.log(statusValue);
        setStatus(statusValue ? 0 : 1);

        const data = {
            "merchantId": index,
            "status": statusValue ? 0 : 1,
        };

        api.post("merchant/updateSettlementStatus", data)
            .then((response) => {
                if (response.data.statusCodeValue === 200) {
                    toast.success(response.data.body);
                } else {
                    toast.error(response.data.error);
                }
            })
            .catch((error) => {
                if (error.response && error.response.status === 403) {
                    toast.error("You do not have permission to perform this action.");
                    return;
                }
            });
    }

    return (
        <ToggleButton
            value="check"
            selected={status !== 0}
            style={status !== 0 ? { backgroundColor: 'rgba(0, 250, 0, 0.08)' } : {}}
            onChange={() => changeMerchantStatus(status !== 0)}
        >
            <CheckIcon />
        </ToggleButton>
    );
}

MerchantSettlementStatusChangeSelectField.propTypes = {
    index: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired,
};

export default MerchantSettlementStatusChangeSelectField;
